document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('main-product-image');
  const thumbnailButtons = document.querySelectorAll('.thumbnail-button');

  if (mainImage) {
    thumbnailButtons.forEach((button) => {
      button.addEventListener('click', function () {
        mainImage.src = this.dataset.fullUrl;
        mainImage.alt = this.dataset.alt;

        thumbnailButtons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  const form = document.getElementById('product-form');
  if (!form) {
    return;
  }

  const variantSelects = document.querySelectorAll('.variant-selector');
  const variantIdInput = form.querySelector('input[name="id"]');
  const preorderNote = document.querySelector('[id^="ProductPreorderNote-"]');

  const variantStrings = window.variantStrings || {};
  const labels = {
    addToCart: variantStrings.addToCart || 'Add to cart',
    soldOut: variantStrings.soldOut || 'Sold out',
    unavailable: variantStrings.unavailable || 'Unavailable',
    preOrder: variantStrings.preOrder || 'Pre Order',
    preOrderOutOfStock: variantStrings.preOrderOutOfStock || 'Out of Stock',
  };

  const preorderJsonEl = document.getElementById(`ProductPreorderJson-${form.dataset.productId}`);
  let isPreorder = form.dataset.preorder === 'true';
  let variants = [];

  if (preorderJsonEl) {
    try {
      const preorderData = JSON.parse(preorderJsonEl.textContent);
      isPreorder = Boolean(preorderData.isPreorder);
      variants = Array.isArray(preorderData.variants) ? preorderData.variants : [];
    } catch (error) {
      console.error('Failed to parse preorder variant JSON', error);
    }
  }

  if (!variants.length) {
    const variantsJson = document.getElementById(`ProductJson-${form.dataset.productId}`);
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (error) {
        console.error('Failed to parse product variant JSON', error);
      }
    }
  }

  const variantMap = variants.reduce((map, variant) => {
    if (Array.isArray(variant.options)) {
      map[variant.options.join(' / ')] = variant.id;
    }
    return map;
  }, {});

  function isVariantPurchasable(variant) {
    if (!variant) {
      return false;
    }

    if (!isPreorder) {
      return Boolean(variant.available);
    }

    // Pre-order: in stock when inventory is tracked and qty > 0,
    // or when inventory is not tracked and the variant is available.
    if (variant.inventory_management == null || variant.inventory_management === '') {
      return Boolean(variant.available);
    }

    const qty = Number(variant.inventory_quantity);
    return Number.isFinite(qty) ? qty > 0 : Boolean(variant.available);
  }

  function getSubmitButtonLabel(variant) {
    if (!variant) {
      return labels.unavailable;
    }

    if (isPreorder) {
      return isVariantPurchasable(variant) ? labels.preOrder : labels.preOrderOutOfStock;
    }

    return variant.available ? labels.addToCart : labels.soldOut;
  }

  function updatePreorderNote(show) {
    if (!preorderNote) {
      return;
    }

    if (show) {
      preorderNote.removeAttribute('hidden');
    } else {
      preorderNote.setAttribute('hidden', '');
    }
  }

  function updateAvailabilityUI(variant) {
    const addButton = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    if (!addButton) {
      return;
    }

    const purchasable = isVariantPurchasable(variant);
    addButton.disabled = !purchasable;
    addButton.textContent = getSubmitButtonLabel(variant);
    updatePreorderNote(isPreorder && purchasable);

    if (variantIdInput) {
      variantIdInput.disabled = !purchasable;
    }

    document.querySelectorAll('.btn-buy-now').forEach((buyNowButton) => {
      buyNowButton.disabled = !purchasable;
    });
  }

  function getSelectedVariant() {
    if (!variants.length) {
      return null;
    }

    const selectedOptions = [];
    document.querySelectorAll('.variant-selector:checked').forEach((select) => {
      selectedOptions.push(select.value);
    });

    if (selectedOptions.length) {
      const variantId = variantMap[selectedOptions.join(' / ')];
      if (variantId) {
        return variants.find((v) => String(v.id) === String(variantId)) || null;
      }
    }

    if (variantIdInput?.value) {
      return variants.find((v) => String(v.id) === String(variantIdInput.value)) || null;
    }

    return variants[0] || null;
  }

  function updateVariantId() {
    const variant = getSelectedVariant();
    if (!variant) {
      return;
    }

    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    const priceElement = document.querySelector('.product-price');
    if (priceElement && variant.price != null) {
      const symbol = priceElement.dataset.currencySymbol || '';
      priceElement.textContent = symbol + parseFloat((variant.price / 100).toFixed(2)).toLocaleString();
    }

    updateAvailabilityUI(variant);
  }

  variantSelects.forEach((select) => {
    select.addEventListener('change', updateVariantId);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const submitButton = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    const variantId = variantIdInput?.value;
    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = parseInt(quantityInput?.value || '1', 10);
    const currentVariant = variants.find((v) => String(v.id) === String(variantId));

    if (!submitButton || !variantId) {
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then(() => {
        submitButton.textContent = 'Added to cart!';

        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            const cartCount = document.querySelector('.cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
          });

        setTimeout(() => {
          updateAvailabilityUI(currentVariant);
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        submitButton.textContent = 'Error - Try Again';
        submitButton.disabled = false;
      });
  });

  updateVariantId();
});
